import { ROUTES } from "./clientRoutes";
import { ICON_SVG } from "./iconsvg";

export const TRANSACTION_TYPES = {
  PURCHASE: 1,
  CREDIT: 2,
  WAGE: 3,
  TRANSFER: 4,
  WITHDRAWAL: 5,
  ODT: 6,
  CASHPICKUP: 7,
  MONEY_TRANSFER: 8,
  PUSH_TO_CARD: 9,
  WU_TO_ACCOUNT: 10,
  MC_TO_ACCOUNT: 11,
  MOBILE_WALLET: 12,
};

export const TRANSACTION_SERVICE_TYPES = {
  TO_ACCOUNT: 7
}

export const CASH_PICKUP_NETWORK_TYPES = {
  UNKNOWN: 0,
  PICKUP_ANYWHERE: 1,
  WITHIN_NETWORK: 2,
  DIRECTED: 3,
  SUSPENDED: 4,
};

export const SELECTION_TYPES = {
  COUNTRIES: "COUNTRIES",
};

export const PASSPORT_STATUSES = {
  UNKNOWN: 0,
  EXPIRED: 1,
  INVALID_DATE: 2,
  VALID: 3,
};

export const USER_PROFILE_FIELDS = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  PHONE_NUMBER: "phoneNumber",
  PHONE: "phone",
  EMAIL: "email",
  COUNTRY: "country",
  COUNTRY_ISO: "countryIso",
  CITY: "city",
  POSTAL_CODE: "postalCode",
  PROVINCE: "province",
  STATE: "state",
  STATE_PROVINCE_ISO: "stateProvinceIso",
  STATE_PROVINCE_NAME: "stateProvinceName",
  LINE_1: "line1",
  LINE_2: "line2",
  ADDRESS_LINE_1: "addressLine1",
  ADDRESS_LINE_2: "addressLine2",
  ZIP_POSTAL: "zipPostal",
};

export const RATE_CARD_FIELDS = {
  TOTAL_COST: 1,
  TOTAL_RECEIVE_AMOUNT: 2,
  SEND_AMOUNT: 3,
  FEE: 4,
  PROMO_CODE: 7,
  FX_RATE: 30
};

export const SUCCESS_FIELDS = {
  TIME_UNTIL_AVAILABLE: 28,
  REFERENCE_NUMBER: 31,
  TRANSFER_DATE: 33,
};

export const ACTION_DISPLAY_TYPES = {
  PRIMARY: 1,
  SECONDARY: 2,
  TERTIARY: 3,
  LINK: 4,
  RECEIPT: 5,
  TEXT: 6,
};

export const ACTION_DISPLAY_TYPES_BY_NAME = {
  PRIMARY: "Primary",
  SECONDARY: "Secondary",
  TERTIARY: "Tertiary",
  LINK: "Link",
  RECEIPT: "Receipt",
  TEXT: "Text"
};

export const ACTION_TYPES = {
  CONFIRM: 1,
  DISMISS: 2,
  MODAL: 3,
};

export const ACTION_TYPES_BY_NAME = {
  CONTINUE: "Continue",
  DISMISS: "Dismiss",
  CHILD_ACTION: "ChildAction",
  BACK: "Back"
}

export const FIELD_TYPES = {
  PHONE_NUMBER: 1,
  CURRENCY: 2,
  BOOL: 3,
  DATE: 4,
  INTEGER: 5,
  DECIMAL: 6,
  SELECT: 7,
  COUNTRY: 8,
  EMAIL: 9,
  TEXT: 10,
  CASCADING_SELECT: 11,
  PIN: 12,
  TEXTAREA: 13,
  FILE: 14,
  SELECT_TEXT_COMBO: 15,
  EXPIRATION_DATE: 16,
  RADIO: 17,
};

export const FIELD_TYPES_BY_NAME = {
  PHONE_NUMBER: "PhoneNumber",
  CURRENCY: "Currency",
  BOOL: "Boolean",
  DATE: "Date",
  INTEGER: "Integer",
  DECIMAL: "Decimal",
  DROPDOWN: "Dropdown",
  COUNTRY: "Country",
  EMAIL: "Email",
  TEXT: "Text",
  SELECT: "Select",
  CASCADING_DROPDOWN: "CascadingDropdown",
  PIN: "Pin",
  TEXTAREA: "TextArea",
  HORIZONTAL_RULE: "HorizontalRule",
  ICON_MULTILINE_TEXT: "IconMultilineText"
};

export const ICONS = {
  PERSONAL_INFO: 1,
  NEWS_DASHBOARD: 2,
  LOCATION: 3,
  CHEVRON_RIGHT: 4,
  DOWNLOAD: 5,
  PENCIL: 6,
  INFO: 7,
  CLOCK: 8,
  GREEN_CHECK: 9,
  WARNING_INFO: 10,
  INFO_GREY: 11,
  EXTERNAL_LINK_BLUE: 12,
  PRINT: 13,
  INFO_WHITE: 14,
  COPY_BLUE: 15,
  CHEVRON_FIRST: 16,
  CHEVRON_FIRST_DISABLED: 17,
  CHEVRON_PREVIOUS: 18,
  CHEVRON_PREVIOUS_DISABLED: 19,
  CHEVRON_NEXT: 20,
  CHEVRON_NEXT_DISABLED: 21,
  CHEVRON_LAST: 22,
  CHEVRON_LAST_DISABLED: 23,
  LOCK_BLUE: 24,
  KEY: 25,
};

export const ICONS_ALT_TEXT = {
  1: "Personal Info",
  2: "News Dashboard",
  3: "Location",
  4: "Chevron Right",
  5: "Download",
  6: "Pencil",
  7: "Info",
  8: "Clock",
  9: "Green Check",
  10: "Warning Info",
  11: "Info Grey",
  12: "External Link",
  13: "Print",
  14: "Info",
  15: "Copy",
  16: "Go to first page",
  17: "Go to first page - is currently disabled",
  18: "Go to previous page",
  19: "Go to previous page - is currently disabled",
  20: "Go to next page",
  21: "Go to next page - is currently disabled",
  22: "Go to last page",
  23: "Go to last page - is currently disabled",
  24: "Lock",
  25: "Key",
}

export const FIELD_CATEGORIES = {
  SENDER: "Sender",
  RECEIVER: "Receiver",
  NETWORK_PAYER: "Network Payer",
  FRAUD_WARNING: "FraudWarning",
  BANK: "Bank"
};

export const MONEY_TRANSFER_STEPS = {
  COUNTRY_AND_AMOUNT: "COUNTRY_AND_AMOUNT",
  RATES: "RATES",
  NETWORK_PAYOUT_INFO: "NETWORK_PAYOUT_INFO",
  SENDER_INFO: "SENDER_INFO",
  RECEIVER_INFO: "RECEIVER_INFO",
  FRAUD_WARNING: "FRAUD_WARNING",
  REVIEW: "REVIEW",
  SUCCESS: "SUCCESS",
  RECEIPT: "RECEIPT"
};

export const RELATED_FIELDS = {
  PREDECESSOR: "PREDECESSOR",
  SUCCESSOR: "SUCCESSOR",
  GROUP_TARGET: "GROUP_TARGET",
  GROUP_SOURCE: "GROUP_SOURCE"
};

export const ACCEPTANCE_BEHAVIOR = {
  DO_NOT_SHOW: "DO_NOT_SHOW",
  SHOW_AND_DONT_REQUIRE: "SHOW_AND_DONT_REQUIRE",
  SHOW_AND_REQUIRE: "SHOW_AND_REQUIRE",
};

export const RESET_PIN_STEPS = {
  CURRENT_PIN: "CURRENT_PIN",
  FORGOT_PIN: "FORGOT_PIN",
  CHANGE_PIN: "CHANGE_PIN",
};

export const FORGOT_PASSWORD_STEPS = {
  ENTER_USERNAME: "ENTER_USERNAME",
  RESET_OPTION: "RESET_OPTION",
  PERSONAL_INFO_ENTRY: "PERSONAL_INFO_ENTRY",
  EMAIL_ENTRY: "EMAIL_ENTRY",
  EMAIL_SUCCESS: "EMAIL_SUCCESS",
  NEW_PASSWORD_ENTRY: "NEW_PASSWORD_ENTRY",
  PASSWORD_SUCCESS: "PASSWORD_SUCCESS",
};

export const INFO_MODAL_PICTURES = {
  2: ICON_SVG.LAST_SIX_DIGITS,
  3: ICON_SVG.EXP_DATE,
};

export const SERVICE_PROVIDER_FIELD_ID = {
  CARD_LAST_SIX: "cardLastSix",
  CARD_EXP_DATE: "cardExpirationDate",
  DATE_OF_BIRTH: "dateOfBirth",
};

export const PASSWORD_RULE_STATUS = {
  NEUTRAL: "neutral",
  PASSED: "passed",
  FAILED: "failed",
};

export const ERROR_TYPE = {
  None: 0,
  Field: 1,
  Screen: 2,
  OK: 3,
  ContactSupport: 4,
  Dashboard: 5,
  Login: 6,
  ContactSupportAndDashboard: 7,
  ContactSupportAndLogin: 8,
};

export const CARD_TYPE = {
  VISA: 1,
  MASTER_CARD: 2,
};

export const CREDIT_CARD_TYPE_ID = {
  1: 'Visa',
  2: 'Mastercard'
};

export const AUTH_INFO_TYPE = {
  Password: "Password",
  Authenticated: "Authenticated",
  SecurityQuestion: "SecurityQuestion",
  FaceCheck: "FaceCheckLogin",
  Totp: 'Totp'
};

export const DIRECTIVE_TYPE = {
  Dashboard: "Dashboard",
  FaceCheckEnrollment: "FaceCheckEnrollment",
};

export const APP_STATE = {
  Initializing: "Initializing",
  Ready: "Ready",
};

export const SUPPORT_CATEGORY = {
  ForgotSecurityQuestion: "forgot_security_question",
  Facecheck: "facecheck",
};

export const REQUEST_STATUS = {
  Loading: "Loading",
  Complete: "Complete",
};

export const IN_APP_MESSAGE_TYPE = {
  ACKNOWLEDGEMENT: "Acknowledgement",
  APP_UPDATE_REQUIRED: "AppUpdateForce",
  APP_UPDATE_OPTIONAL: "AppUpdateOptional",
  SECURITY_QUESTION_UPDATE_REQUIRED: "SecurityQuestionUpdateForce",
  SECURITY_QUESTION_UPDATE_OPTIONAL: "SecurityQuestionUpdateOptional",
  FACECHECK_ENROLLMENT: "FaceCheckEnrollment", //FaceCheck intro page
};

export const LOCAL_STORAGE = {
  Username: "username",
};

export const ENROLLMENT_COMMUNICATIONS_PREFERENCES = {
  CUSTOM_DROPDOWN: "99",
  OCEAN_PAY_NEWS: "opNews",
  OCEAN_PAY_CARD: "opCard",
  BANK_NOTIFICATIONS: "bankNotifs",
  US_ID: 228,
  FEATURE_FLAGS: {
    DISABLE_FACECHECK: "12099-disable-facecheck",
  },
};

export const TOTP_FLOW = {
  SCREENS: {
    HOW_IT_WORKS: 1,
    LINK_AUTHENTICATOR_APP: 2,
    VERIFY_AUTHENTICATOR_APP: 3,
    SUCCESS: 4
  }
}

export const SUPPORT_CONVERSATION_CATEGORY_TYPES = {
  BANK_ACCOUNT: 'bank_account',
  MY_CARD: 'my_card',
  TRANSACTION_QUESTION_DISPUTE: 'transaction_question/dispute',
  MONEY_TRANSFER: 'money_transfer',
  SOMETHING_ELSE: 'something_else'
}

export const LOCK_STATUS = {
  LOCKED_BY_SUPPORT: 'lockedBySupport',
  LOCKED_BY_USER: 'lockedByUser',
  UNLOCKED: 'unlocked'
}

export const CARD_DIRECTIVE_TYPES = {
  SUPPORT: "SUPPORT",
  MYCARD: "MYCARD",
  SHOW_DETAILS_LEARN_MORE: "MYCARD_SHOW_DETAILS_LEARN_MORE",
  MYCARD_SHOW_DETAILS: "MYCARD_SHOW_DETAILS",
  MYCARD_LOCK_CARD: "MYCARD_LOCK_CARD",
  MYCARD_UNLOCK_CARD: "MYCARD_UNLOCK_CARD",
  MYCARD_SHOW_DETAILS_SETUPFACECHECK: "MYCARD_SHOW_DETAILS_SETUPFACECHECK",
  MYCARD_ACTIVATE_CARD_PHYSICAL: "MYCARD_ACTIVATE_CARD_PHYSICAL",
  MYCARD_ACTIVATE_CARD_INAPP: "MYCARD_ACTIVATE_CARD_INAPP",
  MODAL: "Modal",
  CLOSE_MODAL: "CLOSE_MODAL",
  PUSH_TO_CARD_CLOSE_MODAL: "PUSH_TO_CARD_CLOSE_MODAL",
  MOBILE_WALLET_CONTINUE: "MOBILE_WALLET_CONTINUE",
  PUSH_TO_CARD_CONTINUE: "PUSH_TO_CARD_CONTINUE",
  SEND_MONEY: "SEND_MONEY",
  NEW_TOACCOUNT_OPTIONS_TRY_NOW: "NEW_TOACCOUNT_OPTIONS_TRY_NOW"
}

export const CARD_DIRECTIVE_ROUTES = {
  SUPPORT: 'Support',
  MYCARD: 'MyCard',
  SHOW_CARD_DETAILS_LEARN_MORE: "MYCARD_SHOW_DETAILS_LEARN_MORE",
  MYCARD_CHANGE_PIN: ROUTES.PIN_RESET,
  MYCARD_FAQS: ROUTES.MY_CARD.FAQ,
  MYCARD_ACTIVATE_CARD_PHYSICAL: ROUTES.MY_CARD.ACTIVATE_REPLACEMENT_CARD,
  MYCARD_ACTIVATE_CARD_INAPP: ROUTES.MY_CARD.ACTIVATE_IN_APP_CARD
}

export const MONEY_TRANSFER_PAGES = {
  SENDER: "Sender",
  RECEIVER: "Receiver",
  PAYER_NETWORKS: "PayerNetworks",
  FRAUD_WARNING: "FraudWarning",
  DYNAMIC_FORM: "DynamicForm",
  STATIC_HTML: "StaticHtml"
}

export const MONEY_TRANSFER_FIELD_IDS = {
  ESTIMATED_ARRIVAL: 6,
  PROMO_CODE: 7,
  TRANSACTION_RECEIVER_NAME: 22,
  TRANSACTION_STATUS: 32,
  TRANSACTION_TIME: 53,
  PROVIDER_ADDRESS: 55,
  RECEIPT_TITLE: 56,
  RECEIPT_SUBTITLE: 57,
  RECEIPT_INFO_BOX: 58,
  TRACKING_NUMBER: 59,
  TRANSACTION_DATE: 60,
  BANK_NAME: 71
}

export const MONEY_TRANSFER_DIRECTIVE_TYPES = {
  EXTERNAL_LINK: "ExternalLink",
  MODAL: "Modal",
  CANCEL_MONEY_TRANSFER: "CancelMoneyTransfer",
  SUPPORT: "Support"
}

export const MONEY_TRANSFER_PROVIDER_IDS = {
  WESTERN_UNION: 7,
  MONEYGRAM: 5,
  TRANSFAST: 4
}

export const MONEY_TRANSFER_SUCCESS_TYPES = {
  RECEIPT: "Receipt",
  SUCCESS: "Success"
}

export const MONEY_TRANSFER_STATUS = {
  CANCELED: "Canceled",
  CANCELLED: "Cancelled"
}

export const MONEY_TRANSFER_PROVIDER_NAMES = {
  WESTERN_UNION: "WesternUnion",
  MONEYGRAM: "MoneyGram"
}

export const COUNTRY_IDS = {
  USA: 228,
  MEXICO: 136
}

export const SUPPORT_DOC_IDS = {
  ISSUING_BANK_CARDHOLDER_AGREEMENT: 1,
  COMPANION_CARD_FEES: 12
}

export const COMPANION_CARD_FIELD_REFS = {
  CARDHOLDER_FIRST_NAME: "cardholderFirstNameRef",
  CARDHOLDER_LAST_NAME: "cardholderLastNameRef",
  SHIP_NAME: "shipNameRef",
  EMPLOYEE_ID: "employeeIdRef",
  CARDHOLDER_EMAIL: "emailRef",
  SECONDARY_FIRST_NAME: "secondaryFirstNameRef",
  SECONDARY_LAST_NAME: "secondaryLastNameRef",
  SECONDARY_EMAIL: "secondaryEmailRef",
  DATE_OF_BIRTH: "dateOfBirthRef",
  ADDRESS_LINE_1: "addressLine1Ref",
  ADDRESS_LINE_2: "addressLine2Ref",
  COUNTRY_ID: "countryIdRef",
  CITY: "cityRef",
  STATE_ID: "stateIdRef",
  PROVINCE: "provinceRef",
  ZIP_POSTAL_CODE: "zipPostalCodeRef",
  ID_FILE: "idFileRef",
  IDENTIFICATION_TYPE_ID: "identificationTypeIdRef",
  ISSUING_COUNTRY: "issuingCountryRef",
  ID_NUMBER: "idNumberRef",
}

export const DOCUMENT_TYPE_IDS = {
  WUBS_COUNTRIES_LINK: 22
}

export const MONEY_TRANSFER_RATE_CARD_FIELD_TYPES = {
  LABEL_VALUE: "LabelValue",
  MULTILINE_TEXT: "MultilineText"
}

export const BANK_ACCOUNT_STATUS = {
  AVAILABLE: 1,
  INCOMPLETE: 3,
  UNDER_REVIEW: 4,
  DECLINED: 5
}

export const ON_DEMAND_TRANSFER_PROVIDERS = {
  CONVERA_WUBS: 1,
  COREPAY_CAMBRIDGE: 3
}

export const FOOTER_DISCLAIMER_LINKS_IDS = {
  PRIVACY_STATEMENT: "PRIVACYSTATEMENT",
  TERMS_AND_CONDITIONS: "TERMSANDCONDITIONS",
  ESIGN: "ESIGN",
}

export const CARD_TRANSACTIONS = {
  NUM_TO_GET: 20
}

export const TRANSFER_METHODS = {
  PUSH_TO_CARD: "PUSH_TO_CARD",
  TO_ACCOUNT: "BANK_ACCOUNT",
  MOBILE_WALLET: "MOBILE_WALLET",
}

export const BANK_ACCOUNT_CARD_TYPES = {
  ODT: "ODT",
  BANK_ACCOUNT: "BANK_ACCOUNT"
}

export const CURRENCY_CODES = {
  USD: "USD",
  EUR: "EUR",
  AUD: "AUD",
}

export const CURRENCY_NAMES = {
  USD: "US Dollar",
  EUR: "Euro",
  AUD: "Australian Dollar",
}

export const COUNTRY_2_DIGIT_ISO_CODES = {
  US: "US",
}

export const BANK_ACCOUNT_FORM_FIELDS = {
  DESTINATION_COUNTRY: "destinationCountry",
  DESTINATION_CURRENCY: "destinationCurrency",
  EMAIL_ADDRESS: "BankEmailAddress",
  CONFIRM_EMAIL_ADDRESS: "confirmEmailAddress",
  BENEFICIARY_NAME: "BeneficiaryName",
  BENEFICIARY_STREET_ADDRESS: "BeneficiaryStreetAddress",
  BENEFICIARY_CITY: "BeneficiaryCity",
  BENEFICIARY_COUNTRY: "BeneficiaryCountry",
  BENEFICIARY_STATE_PROVINCE: "BeneficiaryStateProvince",
  BENEFICIARY_PHONE_NUMBER: "BeneficiaryPhoneNumber",
  NATURE_OF_RELATIONSHIP: "NatureofRelationship",
  RESIDENTIAL_STATUS: "ResidentialStatus",
  SPECIFY_VAT: "SpecifyVat",
  BANK_NAME: "BankName",
  BANK_STREET_ADDRESS: "BankStreetAddress",
  BANK_CITY: "BankCity",
  BANK_COUNTRY: "BankCountry",
  BANK_ACCOUNT: "BankAccount",
  BANK_ROUTING_CODE: "BankRoutingCode",
  BANK_ACCOUNT_TYPE: "BankAccountType",
}

export const REVIEW_BANK_ACCOUNT_DETAILS = {
  BENEFICIARY_FIELD_NAMES: ["BeneficiaryName", "BeneficiaryStreetAddress", "BeneficiaryCity", "BeneficiaryStateProvince", "BeneficiaryPostalCode",
    "BeneficiaryCity", "BeneficiaryIDCode", "BeneficiaryCountry", "BeneficiaryPhoneNumber", "BeneficiaryContactName", "BeneficiaryPassportNumber",
    "BeneficiaryIDCode", "BeneficiaryTaxID", "BeneficiaryContactName2", "ResidentialStatus", "BeneficiaryTypeId", "NatureofRelationship", "SpecifyVat"
  ],
  BANK_FIELD_NAMES: ["BankName", "BankStreetAddress", "BankAccountType", "BankCity", "BankStateProvince", "BankPostalCode", "BankCountry", "BankAccount", "BankRoutingCode", "SwiftBranchDetails", "BankSwiftAddress"]
}

export const BANK_ACCOUNT_FIELDS_SECTIONS = {
  BENEFICIARY: "Beneficiary Details",
  BANK: "Bank Details",
  INTERMEDIARY: "Intermediary Bank Details"
}

export const BANK_ACCOUNT_EDGE_CASES = {
  ROUTING_CODE: "RoutingCode",
  LOCAL_ROUTING_NUMBER: "localRoutingNumber",
  ACCOUNT: "Account",
  ACCOUNT_NUMBER: "AccountNumber",
  STREET_ADDRESS: "StreetAddress",
  ADDRESS: "Address",
  DESTINATION_COUNTRY_ID: "destinationCountryId",
  DESTINATION_CURRENCY_ID: "destinationCurrencyId",
  DESTINATION_CURRENCY: "destinationCurrency",
  COUNTRY: "Country",
  COUNTRY_ISO: "CountryIso",
  COUNTRY_ID: "CountryId",
  STATE_PROVINCE: "StateProvince",
  STATE_OR_PROVINCE: "StateOrProvince",
  NATURE_OF_RELATIONSHIP: "NatureofRelationship",
  NATURE_OF_RELATIONSHIP_TYPE_ID: "NatureOfRelationshipTypeId",
  SWIFT_ADDRESS: "SwiftAddress",
  SWIFT_CODE: "SwiftCode",
  BENEFICIARY_TAX_ID: "BeneficiaryTaxID",
  BENEFICIARY_TAX_ID_NUMBER: "BeneficiaryTaxIdNumber",
  TAX_ID: "taxID",
  TAX_ID_NUMBER: "taxIDNumber"
}

export const PAGINATION_BUTTONS = {
  FIRST: 1,
  PREV: 2,
  NEXT: 3,
  LAST: 4
}
export const BANK_ACCOUNT_FLOW_TYPES = {
  NEW: "NEW",
  EDIT: "EDIT"
} as const;

export const ALLOCATION_TABLE_TYPES = {
  AVAILABLE: "available",
  UNAVAILABLE: "unavailable"
} as const;

export const ALLOCATION_TYPES = {
  ALL_TO_CARD: 1,
  PERCENTAGE: 2,
  FIXED: 3,
}

export const PARTICIPANT_ALLOCATION_OPTIONS = {
  PERCENT: 1,
  FLAT: 2
}

export const ENROLLMENT_KEYS = {
  ACCESS_TOKEN_KEY: "access_token",
  REFRESH_TOKEN_KEY: "refresh_token",
  USER_DATA_KEY: "user_data",
  CYPHER: "6<Q#bu?Vr<;8%!4d>C8p(B.Ax*"
}

export const RR_TRANSFER_METHODS = {
  MOBILE_WALLET: "MOBILE_WALLET",
  SEND_WITH_BRIGHTWELL: "BANK_ACCOUNT",
  PUSH_TO_CARD: "PUSH_TO_CARD",
}

export const RR_RSP = {
  VISA: "VISA",
  MASTERCARD: "MASTERCARD"
}

export const SEND_MONEY_TRANSFER_METHOD_IDS = {
  MOBILE_WALLET: 8,
  SEND_WITH_BRIGHTWELL: 2,
  PUSH_TO_CARD: 3,
} as const;

export const SEND_MONEY_RECIPIENT_TYPES = {
  MYSELF: "myself",
  SOMEONE_ELSE: "someoneElse",
} as const;

export const SEND_MONEY_WORKFLOW_STEPS = {
  REVIEW: "review",
} as const;

/** Currencies whose flag isn't the selected country's: EUR spans countries; USD shows the US flag. */
export const CURRENCY_FLAG_OVERRIDES: Record<string, string> = {
  EUR: "EU",
  USD: "US",
};

export const CARD_TYPES = {
  IN_APP: "IN_APP",
  PHYSICAL: "PHYSICAL",
}

export const ISSUING_BANK_NAMES = {
  2: "Bancorp",
  4: "TPL"
}

export const API_FIELD_LABELS = {
  REFERENCE_NUMBER: "Reference number"
}

export const LOCAL_STORAGE_KEYS = {
  REFRESH_TOKEN: "refresh_token",
  USERNAME: "username",
  US_STATES: "us_states_cache",
  PREV_BENEFICIARY_COUNTRY: "prev_beneficiary_country"
}

export const EXPIRATION_DATE_FIELD_TYPES = {
  MONTH: "month",
  YEAR: "year"
}

/** `{icon:<path>}` token anywhere in a display string; surrounding whitespace is consumed with it. */
export const ICON_TOKEN_REGEX = /\s*\{icon:([^}]+)\}\s*/;

/** `{name}` tokens in a dynamic-form optionsUrl; global so replace() fills every token. */
export const OPTIONS_URL_TOKEN_REGEX = /\{([^}]+)\}/g;